import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export default function RequiredWhenValidator(testControl: AbstractControl, testValue: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (testControl.value === testValue) {
      return !control.value ? { requiredWhen: { valid: false, message: `Field is required when ${testValue}` } } : null;
    }
    return null;
  };
}
